import { render, staticRenderFns } from "./BookletTextBlockChange.vue?vue&type=template&id=1f153026&scoped=true&"
import script from "./BookletTextBlockChange.vue?vue&type=script&lang=js&"
export * from "./BookletTextBlockChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f153026",
  null
  
)

export default component.exports